"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Display_1 = require("./Display");
var Snackbar_1 = __importDefault(require("@material-ui/core/Snackbar"));
var Paper_1 = __importDefault(require("@material-ui/core/Paper"));
var AlertContext = react_1.createContext([
    {
        info: '',
        success: '',
        warning: '',
        error: '',
    },
    {
        setInfo: function () { return console.warn('AlertProvider not initialized'); },
        setError: function () { return console.warn('AlertProvider not initialized'); },
        setWarning: function () { return console.warn('AlertProvider not initialized'); },
        setSuccess: function () { return console.warn('AlertProvider not initialized'); },
    },
]);
exports.useAlertContext = function () { return react_1.useContext(AlertContext); };
exports.useSetAlertInfo = function () { return react_1.useContext(AlertContext)[1].setInfo; };
exports.useSetAlertError = function () { return react_1.useContext(AlertContext)[1].setError; };
exports.useSetAlertSuccess = function () { return react_1.useContext(AlertContext)[1].setSuccess; };
exports.useSetAlertWarning = function () { return react_1.useContext(AlertContext)[1].setWarning; };
exports.AlertProvider = function (_a) {
    var children = _a.children;
    var _b = react_1.useState({}), _c = _b[0], info = _c.info, error = _c.error, success = _c.success, warning = _c.warning, setState = _b[1];
    var setInfo = function (info) { return setState({ info: info }); };
    var setWarning = function (warning) { return setState({ warning: warning }); };
    var setSuccess = function (success) { return setState({ success: success }); };
    var setError = function (error) { return setState({ error: error }); };
    return (react_1.default.createElement(AlertContext.Provider, { value: [
            { info: info, error: error, success: success, warning: warning },
            { setInfo: setInfo, setError: setError, setSuccess: setSuccess, setWarning: setWarning },
        ] },
        children,
        react_1.default.createElement(Snackbar_1.default, { anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, open: !!error || !!info || !!success, autoHideDuration: 6000, onClose: function () { return setState({}); } },
            react_1.default.createElement(Paper_1.default, null, error ? (react_1.default.createElement(Display_1.ErrorDisplay, { variant: "outlined", error: error, onClose: function () { return setState({}); } })) : info ? (react_1.default.createElement(Display_1.InfoDisplay, { variant: "outlined", message: info, onClose: function () { return setState({}); } })) : success ? (react_1.default.createElement(Display_1.SuccessDisplay, { variant: "outlined", message: success, onClose: function () { return setState({}); } })) : warning ? (react_1.default.createElement(Display_1.WarningDisplay, { variant: "outlined", message: warning, onClose: function () { return setState({}); } })) : null))));
};
//# sourceMappingURL=context.js.map